import type {
  Coupon,
  GetBillingAccountOverviewResponse,
} from "@nlc/shared-types";

import { addRenewalDays } from "../../credits/utils/renewal-date";

export function addCredit(
  overview: GetBillingAccountOverviewResponse,
  amount: string,
): GetBillingAccountOverviewResponse {
  const balanceInCents =
    toCents(overview.creditBalance.amount) + toCents(amount);

  return {
    ...overview,
    creditBalance: {
      ...overview.creditBalance,
      amount: (balanceInCents / 100).toFixed(2),
    },
  };
}

export function adjustRenewalDate(
  overview: GetBillingAccountOverviewResponse,
  days: number,
): GetBillingAccountOverviewResponse {
  return {
    ...overview,
    upcomingPayment: {
      ...overview.upcomingPayment,
      renewalDate: addRenewalDays(overview.upcomingPayment.renewalDate, days),
    },
  };
}

export function addCoupon(
  overview: GetBillingAccountOverviewResponse,
  coupon: Coupon,
): GetBillingAccountOverviewResponse {
  return {
    ...overview,
    coupons: [...overview.coupons, { code: coupon.code, id: coupon.id }],
  };
}

function toCents(amount: string): number {
  return Math.round(Number(amount) * 100);
}
